import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalMining() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Mining: Revolutionizing Operations with 5G Connectivity
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance safety, efficiency, and automation in mining environments with
          FlexNet’s robust private 4G/5G solutions.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Mining
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Enhance safety, efficiency, and automation in mining environments
              with FlexNet’s robust private 4G/5G solutions.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://www.mining.com/wp-content/uploads/2023/05/AdobeStock_575591372-1024x683.jpeg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Manufacturing?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Manufacturing </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            {" "}
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>

            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Revolutionize Your Mining Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Centralized Network Control",
    detail: "Manage networks with a single control hub for remote operations.",
    icon: "pi pi-globe",
  },
  {
    title: "Real-Time Asset Tracking",
    detail: "Monitor and manage assets efficiently in rugged environments.",
    icon: "pi pi-map-marker",
  },
  {
    title: "Enhanced Worker Safety",
    detail:
      "Use IoT-enabled wearables for real-time health and safety monitoring.",
    icon: "pi pi-shield",
  },
  {
    title: "Automated Monitoring & AI-driven Decisions",
    detail: "Leverage AI-powered systems for proactive site management.",
    icon: "pi pi-cog",
  },
  {
    title: "Predictive Maintenance",
    detail: "Minimize downtime with AI-driven predictive analytics.",
    icon: "pi pi-chart-line",
  },
];

const useCases = [
  {
    title: " 1: Worker Safety with Smart Helmets and Wearables",
    description:
      "Equip workers with 4G/5G-enabled smart helmets and wearables for real-time health and safety monitoring.",
    benefits: [
      { title: "Emergency call and video call features", icon: "pi pi-phone" },
      { title: "Fall detection and geo-fencing", icon: "pi pi-map" },
      {
        title: "Automatic photo uploads and voice broadcasting",
        icon: "pi pi-upload",
      },
    ],
    devices: [
      { title: "4G/5G Smart Helmets", icon: "pi pi-mobile" },
      { title: "Wearables", icon: "pi pi-clock" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Worker Safety Monitoring Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 2: Drone Inspection for Remote Monitoring",
    description:
      "Utilize 5G-connected drones for scheduled inspections of mining sites, terrain analysis, and safety monitoring.",
    benefits: [
      {
        title: "Detect landslides, hazardous zones, and safety breaches",
        icon: "pi pi-exclamation-triangle",
      },
      {
        title: "Enable scheduled take-offs for automated monitoring",
        icon: "pi pi-calendar",
      },
      {
        title: "Provide real-time data transmission to control centers",
        icon: "pi pi-globe",
      },
    ],
    devices: [
      { title: "5G Drones", icon: "pi pi-send" },
      { title: "High-Resolution Cameras", icon: "pi pi-camera" },
      { title: "AI Analytics", icon: "pi pi-lightbulb " },
    ],
    applications: [
      {
        title: "Drone Inspection and Monitoring Systems",
        icon: "pi pi-desktop",
      },
    ],
  },
  {
    title: " 3: IoT Solutions for Environmental Monitoring",
    description:
      "Deploy IoT sensors to monitor environmental factors such as hazardous gas levels, displacement, and meteorological conditions.",
    benefits: [
      { title: "Ensure regulatory compliance", icon: "pi pi-check-circle" },
      {
        title: "Early detection of hazardous conditions",
        icon: "pi pi-exclamation-circle",
      },
      { title: "Enhance overall site safety", icon: "pi pi-shield" },
    ],
    devices: [
      { title: "Hazardous Gas Detectors", icon: "pi pi-cloud" },
      { title: "Meteorological Sensors", icon: "pi pi-sun" },
      { title: "Displacement Monitors", icon: "pi pi-arrows-alt" },
    ],
    applications: [
      { title: "Environmental Monitoring Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 4: Predictive Maintenance with IoT Sensors",
    description:
      "Leverage IoT sensors to predict equipment failures and schedule maintenance proactively, minimizing unplanned downtime.",
    benefits: [
      {
        title: "Real-time monitoring of machinery health",
        icon: "pi pi-clock",
      },
      {
        title: "Predict potential breakdowns before they occur",
        icon: "pi pi-chart-line",
      },
      { title: "Extend equipment lifespan", icon: "pi pi-cog" },
    ],
    devices: [
      { title: "Vibration Sensors", icon: "pi pi-sliders-h" },
      { title: "Temperature Sensors", icon: "pi pi-sun" },
      { title: "Pressure Sensors", icon: "pi pi-gauge" },
    ],
    applications: [
      { title: "Predictive Maintenance Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: AI-Enabled Asset Tracking with Digital Twin Technology",
    description:
      "Implement digital twin technology to create real-time virtual replicas of mining assets for optimized tracking and operational insights.",
    benefits: [
      {
        title: "Real-time monitoring and data-driven decision making",
        icon: "pi pi-chart-bar",
      },
      {
        title: "Simulation and optimization of operations",
        icon: "pi pi-server",
      },
      {
        title: "Predictive maintenance alerts",
        icon: "pi pi-exclamation-circle",
      },
    ],
    devices: [
      { title: "IoT Devices", icon: "pi pi-cloud" },
      { title: "Edge Computing Servers", icon: "pi pi-globe" },
      { title: "Digital Twin Platforms", icon: "pi pi-clone" },
    ],
    applications: [
      { title: "Digital Twin Management Systems", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 6: Automated Monitoring with AI Cameras",
    description:
      "Deploy AI-powered 4G/5G cameras for real-time monitoring, PPE detection, and intrusion alerts in mining environments.",
    benefits: [
      {
        title: "Detect smoke, fire, and unauthorized intrusions",
        icon: "pi pi-exclamation-circle",
      },
      {
        title: "Ensure PPE compliance and worker safety",
        icon: "pi pi-check-circle",
      },
      {
        title: "Enhance site security with automated alerts",
        icon: "pi pi-bell",
      },
    ],
    devices: [
      { title: "4G/5G AI Cameras", icon: "pi pi-camera" },
      { title: "IoT Security Platforms", icon: "pi pi-lock" },
    ],
    applications: [
      {
        title: "AI Surveillance and Monitoring Systems",
        icon: "pi pi-desktop",
      },
    ],
  },
];
